// NAVIG8 GA4 Event Tracking
// Wraps window.gtag() — no-ops gracefully when GA4 is absent.

function gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

/**
 * Fire a GA4 custom event.
 * @param {string} eventName - e.g. "signup", "deal_submitted", "quote_sent"
 * @param {object} [params]  - arbitrary key/value pairs sent with the event
 */
export function trackEvent(eventName, params = {}) {
  gtag("event", eventName, params);
}

/**
 * Set persistent user properties on the GA4 data stream.
 * @param {object} props - { role, company, state, is_demo, ... }
 */
export function setUserProperties(props) {
  gtag("set", "user_properties", props);
}

/**
 * Log a virtual page-view (for SPA navigation).
 * @param {string} pageName - human-readable page identifier
 */
export function trackPageView(pageName) {
  gtag("event", "page_view", {
    page_title: pageName,
    page_location: typeof window !== "undefined" ? window.location.href : "",
    page_path: typeof window !== "undefined" ? window.location.pathname : "",
  });
}
